export enum MessagesEnum {
  closeFrame = 'close_frame',
  paymentComplete = 'payment_complete'
}
